import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { track } from './posthog';

import {
  BrowserRouter as Router,
  Route,
  Link,
  useParams
} from "react-router-dom";



import "./PhoneData.css";

import DiscountBadge from "./DiscountBadge";

import proctection_LIST from "./_ProtectionList.json";
import prestation_LIST from "./_PrestationList.json";

import { calculerRemisesParItem, calculerTotaux, normaliserParametres, estBatterieEligibleOffre, TYPE_REMISE_BATTERIE } from "./calculRemises";

export default class PhoneData extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedItems : [],
      // discount = montant total des remises posées sur les lignes, déjà déduit
      // de total. discountBatterie en est la part batterie, affichée à part.
      discount: 0,
      discountBatterie: 0,
      total: 0,
      // { <IDArticle> : { pourcentage, type } } — badge affiché sur chaque
      // réparation sélectionnée.
      remisesParItem: {}
    };

    // Event PostHog envoyé une seule fois par affichage de l'écran.
    this.offreBatterieTrackee = false;
  };


  componentDidMount(){

    window.scrollTo({
            top: 0,
            behavior: "smooth",
        })

  }

  static propTypes = {
    onClickFunction: PropTypes.func,
    phoneData: PropTypes.object,
    showPrices: PropTypes.bool
  };





  /*
  printColorOptions(part, colorOptions) {
    if(colorOptions==null)
      return;

    var id="Options"+part;

    return(
      <div class="colorOptions" id={id} style={{display: "none"}}>
      <p>Choisissez votre couleur :</p>
      <p></p>
      {colorOptions.map((color, index) => (
        <label>
					<input type="radio" class="cardRadio" id={id+index} name={part} value={color.value}/>
					<div class="cardColorBorder">
					</div>
					<div class="cardColor" style={{backgroundColor: color.code}}>
					</div>
				</label>
      ))}
      </div>);
  }*/

  printItem(item) {

    // Badge de remise (TICK00299) : affiché sur chaque réparation sélectionnée
    // avec le taux qui lui revient (-10% sur la plus chère, -20% sur les
    // suivantes, -50% sur une batterie secondaire). Rien sur les articles exclus.
    // Calculé depuis state (jamais depuis le DOM : les checkboxes ne sont pas
    // contrôlées).
    const remise           = this.getRemiseItem(item);
    const badgeVisible     = remise != null;
    const estLigneBatterie = Number(item.IsBatterie) === 1;
    const pourcentage      = badgeVisible ? remise.pourcentage : 0;

    // Encart de l'offre batterie, deux états :
    //  - offre acquise : la batterie est cochée et porte effectivement le -50 % ;
    //  - incitation : la batterie n'est pas cochée mais une autre réparation
    //    éligible l'est, donc le -50 % l'attend. Cet état est celui qui sert
    //    à quelque chose et il avait disparu avec TICK00299 : la condition
    //    passait par remisesParItem, alimentée uniquement par selectedItems,
    //    donc l'encart n'apparaissait plus qu'APRÈS l'ajout de la batterie.
    const offreBatterieAcquise = estLigneBatterie && remise != null && remise.type === TYPE_REMISE_BATTERIE;
    const offreBatterieOfferte = estLigneBatterie && !offreBatterieAcquise
                                 && !this.estItemSelectionne(item)
                                 && estBatterieEligibleOffre(item, this.state.selectedItems, this.props.offreBatterie);
    const encartVisible        = offreBatterieAcquise || offreBatterieOfferte;
    const pourcentageOffre     = offreBatterieAcquise ? remise.pourcentage : this.getPourcentageBatterie();

    return(
      <label className="lab">
      <input type="checkbox" className="item-checkbox" value={item.Piece} id={item.Piece} onClick={() => this.onItemClick(item)}/>
      <div className={"phone-data-info-box item-info-box" + (encartVisible ? " offre-batterie-box" : "")}>
        <div className="info-box-label">
          {/* .info-box-label est en row-reverse : le badge déclaré AVANT le texte
              s'affiche à sa droite (picto | libellé | badge). */}
          {badgeVisible &&
          <span className="offre-batterie-badge">
            <DiscountBadge label={"-" + pourcentage + "%"} variant="bleu"/>
          </span>}
          {item.Piece}
          <img src={item.PictoPath_Piece} className="picto-piece"/>
        </div>
        {this.props.showPrices &&
        <div className="info-box-price">
          {item.PrixTTC}€
        </div>}
        <div className="info-box-price">
        <div class="checkmark">
        <input type="checkbox" className="item-checkbox"/>
        </div>
          </div>
        {encartVisible &&
        <div className="offre-batterie-encart">
          <span className="offre-batterie-encart-icone">⚠️</span>
          {offreBatterieAcquise
            ? <span>Offre exclusive : <b>-{pourcentageOffre}%</b> appliqués sur le remplacement de votre batterie.</span>
            : <span>Offre exclusive : pour toute réparation sur l'appareil, <b>profitez de -{pourcentageOffre}%</b> sur le remplacement de votre batterie !</span>}
        </div>}
      </div>
        {/*<div class="options">
        {this.printColorOptions(item.part, item.colorOptions)}
        </div>*/}
      </label>);
  }

  printItemProtection(item) {
    return(
      <label className="lab">
      <input type="checkbox" className="item-checkbox" value={item.Piece} id={item.Piece} onClick={() => this.onItemClick(item)}/>
      <div className="protection-data-info-box item-info-box-protection">
      <div>
        <img src={item.PictoPath_Piece} className="picto-protection"/>
      </div>
      <div className="box-protection">
        <div className="info-box-label-proctection">
          {item.Piece}
        </div>
        <p className="text-protection">Garantie à vie</p>
      </div>
        {this.props.showPrices &&
        <div className="info-box-price-protection">
          {item.PrixTTC}€
        </div>}
        <div className="info-box-price-protection">
        <div class="checkmark">
        <input type="checkbox" className="item-checkbox"/>
        </div>
          </div>
      </div>
        {/*<div class="options">
        {this.printColorOptions(item.part, item.colorOptions)}
        </div>*/}
      </label>);
  }
  /* Clic sur le choix d'une pièce à réparer */
  onItemClick(item) {

    var array = [...this.state.selectedItems];
    var index = array.indexOf(item);

    if(index === -1)
      array = array.concat(item);

    else
      array.splice(index, 1);

    track('devis_prestation_modifiee', {
      IDArticle: item.IDArticle,
      prix: Number(item.PrixTTC),
      action: index === -1 ? 'ajout' : 'retrait',
      nb_total: array.length,
    });

    // Remises recalculées à chaque clic : le rang d'une réparation change dès
    // qu'une plus chère entre ou sort du panier.
    const remisesParItem = calculerRemisesParItem(array, this.props.offreBatterie);
    const totaux         = calculerTotaux(array, this.props.offreBatterie);

    const discount         = totaux.remise;
    const discountBatterie = totaux.remiseBatterie;
    const total            = totaux.net;

    // Event PostHog à la première apparition du badge batterie (TICK00276).
    if(!this.offreBatterieTrackee && discountBatterie > 0) {
      this.offreBatterieTrackee = true;
      track('devis_offre_batterie_affichee', {
        pourcentage: this.getPourcentageBatterie(),
        nb_prestations: array.length,
      });
    }

    this.setState({
      selectedItems: array,
      discount: discount,
      discountBatterie: discountBatterie,
      total: total,
      remisesParItem: remisesParItem
    });
/*
    if(document.getElementById("Options"+src)!=null)
    {
      if(document.getElementById("Options"+src).style.display=="none")
      {
        document.getElementById("Options"+src).style.display = "flex";
        document.getElementById("Options"+src+"0").checked = true;
      }

      else {
        document.getElementById("Options"+src).style.display = "none";
      }
    }*/
  }

  validateItems(selectedItems, discount, total, discountBatterie) {
    this.props.onClickFunction(selectedItems, discount, total, discountBatterie);
  }

  // ---------------------------------------------------------------------------
  // Remises en pourcentage par réparation (TICK00299, TICK00301). Le calcul
  // faisant foi est côté serveur (addDevis_ModuleDevis + calculRemisesLignes) :
  // ici on rejoue la même règle, uniquement pour l'affichage.
  // ---------------------------------------------------------------------------

  getParametresRemises() {
    return normaliserParametres(this.props.offreBatterie);
  }

  getPourcentageBatterie() {
    return this.getParametresRemises().pourcentage;
  }

  // Remise affichée sur chaque réparation sélectionnée : -10% sur la plus chère,
  // -20% sur les suivantes, -50% sur une batterie secondaire, rien si l'article
  // est exclu ou sous le montant minimum.
  getRemiseItem(item) {
    var remise = this.state.remisesParItem[item.IDArticle];
    return remise != null ? remise : null;
  }

  // selectedItems contient les objets articles eux-mêmes (cf. onItemClick),
  // pas leurs identifiants : on compare sur IDArticle pour ne pas dépendre de
  // l'identité de référence.
  estItemSelectionne(item) {
    var vl_items = this.state.selectedItems;

    for (var i = 0; i < vl_items.length; i++) {
      if (vl_items[i].IDArticle === item.IDArticle) {
        return true;
      }
    }

    return false;
  }

  render() {

    const parametres = this.getParametresRemises();

    return (
      <div className="component-phone-data">
        <div className="results-title">
          Sélectionnez les réparations sur votre {this.props.phoneData.LibelleMarque} {this.props.phoneData.LibelleModele} ?
        </div>
        <div className="results-subtitle">
          Toutes les réparations Phoner sont garanties 12 mois minimum, et bénéficiez de {parametres.tauxWeb}% de remise exclusive en réservant en ligne !
        </div>
        <div className="phone-data-macarons">
          <span className="phone-data-macaron">
            <DiscountBadge label={"-" + parametres.tauxWeb + "%"} variant="bleu"/> Remise Web
          </span>
          <span className="phone-data-macaron">
            <DiscountBadge label={"-" + parametres.tauxSecondaire + "%"} variant="bleu"/> Réparations suivantes
          </span>
          <span className="phone-data-macaron">
            <DiscountBadge label={"-" + parametres.bonusQualiRepar + "€"} variant="vert"/> Bonus QualiRépar (si éligible)
          </span>
        </div>
        <div className="phone-data-container">
          <div className="component-phone-data-picture">
              <img alt={this.props.phoneData.LibelleModele} src={this.props.phoneData.URL_IMG}/>
          </div>
          <div>
            <div className= "component-phone-data-selection">
              <div className="component-phone-data-item-list">
                {this.props.phoneData.ComposantList.map(item => (
                  <div key={item.IDArticle} className="component-phone-data-item-element">
                    {this.printItem(item)}
                  </div>
                ))}
              </div>

              <div className="class-title">
                Besoin d'autre chose ?
              </div>

              <div className="component-phone-data-item-list">

                {prestation_LIST.map(item => (
                  <div key={item.IDArticle} className="component-phone-data-item-element">
                    {this.printItem(item)}
                  </div>
                ))}

              </div>

              <div className="class-title">
                Protection d'écran
              </div>

              <div className="component-phone-data-item-list">

                {proctection_LIST.map(item => (
                  <div key={item.IDArticle} className="component-phone-data-item-element">
                    {this.printItemProtection(item)}
                  </div>
                ))}

              </div>


              <div className="component-phone-data-prices">
                {this.state.discount > 0 &&
                <div className="phone-data-info-box amount-info-box">
                  <div className="info-box-label">
                    Remises sur vos réparations
                  </div>
                  <div className="info-box-price">
                    -{this.state.discount.toFixed(2)}€
                  </div>
                </div>}
                {this.state.discountBatterie > 0 &&
                <div className="phone-data-info-box amount-info-box">
                  <div className="info-box-label">
                    Offre batterie -{this.getPourcentageBatterie()}%
                  </div>
                  <div className="info-box-price">
                    appliquée ✓
                  </div>
                </div>}
                {this.props.showPrices &&
                <div className="phone-data-info-box amount-info-box">
                  <div className="info-box-label">
                    Total
                  </div>
                  <div className="info-box-price">
                    {this.state.total.toFixed(2)}€
                  </div>
                </div>}
              </div>
              <Router>
                <Link to="/recapitulatif">
                  <button className="validate-button" onClick={this.validateItems.bind(this, this.state.selectedItems, this.state.discount, this.state.total, this.state.discountBatterie)}>Aller au récapitulatif</button>
                </Link>
               </Router>
            </div>
            <div className="info-texte">
              Nos tarifs sont donnés à titre indicatifs et doivent être confirmés par nos techniciens en point de vente :)
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/*
<Router>
  <Link to="/recapitulatif">
  </Link>
 </Router>
*/
